import { Card, ETextStyleVariant, SkeletonLine, Text } from '@outdoorsyco/bonfire';
import React from 'react';

import generateTestIdFrom from '@/utility/generateTestIdFrom';
import { isCampgroundTile, ISearchResultTile } from '@/utility/mapSearchResultToTile';

import { ListingTilePrice } from './ListingTilePrice';
import { ListingTileRating } from './ListingTileRating';

type TListingTileContentMinimalProps = {
  listingTile: ISearchResultTile;
};

export const ListingTileContentMinimal = ({ listingTile }: TListingTileContentMinimalProps) => {
  const primaryInfoItems = (() => {
    if (isCampgroundTile(listingTile)) {
      return [listingTile.sitesDisplayText];
    }

    if (listingTile.isStay) {
      return [listingTile.details?.sleeps, listingTile.details?.beds];
    }

    return [listingTile.details?.seats, listingTile.details?.sleeps];
  })().filter(Boolean);

  return (
    <Card.Content className="w-full">
      {(listingTile.loading && (
        <Text component="div" variant={ETextStyleVariant.SmallRegular}>
          <SkeletonLine width="80%" className="bg-gray-200" />
        </Text>
      )) || (
        <Text
          component="div"
          variant={ETextStyleVariant.SmallRegular}
          data-testid={generateTestIdFrom(listingTile.title || '', 'listing-info-1st-line')}>
          {primaryInfoItems.join(', ')}
        </Text>
      )}

      {(listingTile.loading && (
        <Text component="div" variant={ETextStyleVariant.SmallRegular}>
          <SkeletonLine width="50%" className="bg-gray-200" />
        </Text>
      )) ||
        (listingTile.price && (
          <ListingTilePrice
            showDiscount={false}
            priceTextVariant={ETextStyleVariant.SmallRegular}
            periodTextVariant={ETextStyleVariant.SmallRegular}
            {...listingTile.price}
          />
        ))}

      {(listingTile.loading && (
        <Text component="div" variant={ETextStyleVariant.SmallRegular}>
          <SkeletonLine width="50px" className="bg-gray-200" />
        </Text>
      )) ||
        (!!listingTile.details?.ratingNumber && (
          <ListingTileRating
            rating={listingTile.details.ratingNumber}
            quantity={listingTile.details.ratingQtd}
            ratingTextVariant={ETextStyleVariant.SmallRegular}
            quantityTextVariant={ETextStyleVariant.SmallRegular}
          />
        ))}
    </Card.Content>
  );
};
